<h3 class="text-center bg-c-yellow">Education MIS Dashboard</h3>
<div class="container mt-5 mis-dashboard">
  <section>
    <div class="container-fluid">

      <!-- ── Filter Bar ── -->
      <div class="d-flex flex-wrap align-items-center justify-content-center gap-2 mb-4 mt-4">
        <mat-form-field appearance="outline">
          <mat-label>Teacher Type</mat-label>
          <mat-select [(ngModel)]="teachersType" (selectionChange)="onTeacherTypeChange($event)">
            <mat-option value="Active">Active Teachers</mat-option>
            <mat-option value="All">All Teachers</mat-option>
          </mat-select>
        </mat-form-field>

        <app-searchable-select class="col-md-4"
                               [required]="true"
                               [hideSelectAllOption]="true"
                               [options]="centres$ | async"
                               displayKey="centreName"
                               [valueKey]="'centreCode'"
                               placeholder="Select Centre Name"
                               label="Select Centres"
                               [selectedValue]="selectedCentreObjects"
                               [multiple]="true"
                               (selectionChange)="onSelectedCentres($event)"
        ></app-searchable-select>
<!--        <mat-form-field appearance="outline" style="min-width:280px;">-->
<!--          <mat-label>Centre(s)</mat-label>-->
<!--          <mat-select [(ngModel)]="selectedCentres" multiple>-->
<!--            <mat-option *ngFor="let centre of (centres$ | async)" [value]="centre.centreCode">-->
<!--              {{ centre.centreName }}-->
<!--            </mat-option>-->
<!--          </mat-select>-->
<!--          <mat-hint *ngIf="selectedCentres.length > 0">{{ selectedCentres.length }} selected</mat-hint>-->
<!--        </mat-form-field>-->

        <mat-form-field appearance="outline" style="min-width:280px;">
          <mat-label>Date Range</mat-label>
          <mat-date-range-input [rangePicker]="picker">
            <input matStartDate placeholder="Start date" [(ngModel)]="mStartDate">
            <input matEndDate placeholder="End date" [(ngModel)]="mEndDate">
          </mat-date-range-input>
          <mat-hint>DD/MM/YYYY – DD/MM/YYYY</mat-hint>
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>

        <button mat-mini-fab color="accent" (click)="search()" matTooltip="Search">
          <mat-icon>search</mat-icon>
        </button>
        <button mat-mini-fab color="warn" (click)="resetDate()" matTooltip="Clear filters">
          <mat-icon>clear</mat-icon>
        </button>
      </div>

      <!-- ── Stat Cards ── -->
      <div class="row mb-4" *ngIf="educationSessionCounts || groupSessionCounts">

        <!-- Card 1: Individual Sessions -->
        <div class="col-md-3 col-sm-6">
          <mat-card class="info-box7 l-bg-card1 order-info-box7 scale-on-hover">
            <mat-card-title>
              <mat-icon class="me-1">person</mat-icon> Individual Sessions
            </mat-card-title>
            <mat-card-content>
              <h2 class="d-flex justify-content-between align-items-center mt-2">
                <span>{{ educationSessionCounts?.totalSessions || 0 }}</span>
              </h2>
              <div style="font-size:13px; opacity:.85;">
                Total individual education sessions
              </div>
            </mat-card-content>
          </mat-card>
        </div>

        <!-- Card 2: Group Sessions -->
        <div class="col-md-3 col-sm-6">
          <mat-card class="info-box7 l-bg-card2 order-info-box7 scale-on-hover">
            <mat-card-title>
              <mat-icon class="me-1">groups</mat-icon> Group Sessions
            </mat-card-title>
            <mat-card-content>
              <h2 class="d-flex justify-content-between align-items-center mt-2">
                <span>{{ groupSessionCounts?.totalSessions || 0 }}</span>
              </h2>
              <div style="font-size:13px; opacity:.85;">
                Total group education sessions
              </div>
            </mat-card-content>
          </mat-card>
        </div>

        <!-- Card 3: Total Sessions (I + G) -->
        <div class="col-md-3 col-sm-6">
          <mat-card class="info-box7 l-bg-card3 order-info-box7 scale-on-hover">
            <mat-card-title>
              <mat-icon class="me-1">bar_chart</mat-icon> Total (Ind + Grp)
            </mat-card-title>
            <mat-card-content>
              <h2 class="d-flex justify-content-between align-items-center mt-2">
                <span>{{ combinedSessionCounts?.totalSessions || 0 }}</span>
              </h2>
              <div class="d-flex justify-content-between" style="font-size:13px;">
                <span><mat-icon style="font-size:14px;vertical-align:middle;">person</mat-icon> Individual: {{ educationSessionCounts?.totalSessions || 0 }}</span>
                <span><mat-icon style="font-size:14px;vertical-align:middle;">groups</mat-icon> Group: {{ groupSessionCounts?.totalSessions || 0 }}</span>
              </div>
            </mat-card-content>
          </mat-card>
        </div>

<!--        &lt;!&ndash; Card 4: Follow-Up Sessions &ndash;&gt;-->
<!--        <div class="col-md-3 col-sm-6">-->
<!--          <mat-card class="info-box7 l-bg-card4 order-info-box7 scale-on-hover">-->
<!--            <mat-card-title>-->
<!--              <mat-icon class="me-1">update</mat-icon> Follow-Up Sessions-->
<!--            </mat-card-title>-->
<!--            <mat-card-content>-->
<!--              <h2 class="d-flex justify-content-between align-items-center mt-2">-->
<!--                <span>{{ followUpCounts || 0 }}</span>-->
<!--              </h2>-->
<!--              <div style="font-size:13px; opacity:.85;">-->
<!--                Discharge &amp; follow-up assessments-->
<!--              </div>-->
<!--            </mat-card-content>-->
<!--          </mat-card>-->
<!--        </div>-->
      </div>

      <!-- ── Teacher Table ── -->
      <div class="d-flex justify-content-between align-items-center mb-2">
        <h5 class="mb-0">Teacher / Staff Summary</h5>
        <small class="text-muted" *ngIf="mStartDate && mEndDate">
          {{ mStartDate | date:'dd MMM yyyy' }} – {{ mEndDate | date:'dd MMM yyyy' }}
          <span *ngIf="selectedCentres.length > 0"> &bull; {{ selectedCentres.length }} centre(s)</span>
        </small>
      </div>

      <div class="table-responsive">
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z4 w-100 mb-2">

          <!-- Sr No -->
          <ng-container matColumnDef="no">
            <th mat-header-cell *matHeaderCellDef>Sr.</th>
            <td mat-cell *matCellDef="let row; let i=index">{{ i + 1 }}</td>
            <td mat-footer-cell *matFooterCellDef><b>Total</b></td>
          </ng-container>

          <!-- Photo -->
          <ng-container matColumnDef="photo">
            <th mat-header-cell *matHeaderCellDef>Photo</th>
            <td mat-cell *matCellDef="let row">
              <img [src]="getPhoto(row.profileImages)"
                   (error)="onImageError($event)"
                   [alt]="row.userName"
                   style="width:40px;height:40px;border-radius:50%;border:1px solid #ccc;" />
            </td>
            <td mat-footer-cell *matFooterCellDef></td>
          </ng-container>

          <!-- Name -->
          <ng-container matColumnDef="userName">
            <th mat-header-cell *matHeaderCellDef>Teacher Name</th>
            <td mat-cell *matCellDef="let row">
              <b [style.font-style]="row.isSynthetic || row.disabled ? 'italic' : 'normal'">{{ getDisplayName(row) }}</b>
              <span *ngIf="row.isSynthetic || row.disabled" class="badge bg-warning text-dark ms-1" style="font-size: 10px;"
                    matTooltip="This user is not in the system or is disabled">⚠</span>
            </td>
            <td mat-footer-cell *matFooterCellDef></td>
          </ng-container>

          <!-- Centre -->
          <ng-container matColumnDef="centre">
            <th mat-header-cell *matHeaderCellDef>Alloted Centres</th>
            <td mat-cell *matCellDef="let row">
              <ng-container *ngIf="row.centre?.length <= 1">
                {{ row.centre.join(', ') }}
              </ng-container>
              <ng-container *ngIf="row.centre?.length > 1">
                <span *ngIf="!row.expanded">
                  {{ row.centre.slice(0, 1).join(', ') }}
                  <a style="color:#3f51b5;cursor:pointer;" (click)="toggleCentre(row)">+ Read more</a>
                </span>
                <span *ngIf="row.expanded">
                  {{ row.centre.join(', ') }}
                  <a style="color:#3f51b5;cursor:pointer;" (click)="toggleCentre(row)">Read less</a>
                </span>
              </ng-container>
            </td>
            <td mat-footer-cell *matFooterCellDef></td>
          </ng-container>

          <!-- Individual Sessions -->
          <ng-container matColumnDef="individualSessionCount">
            <th mat-header-cell *matHeaderCellDef>Individual</th>
            <td mat-cell *matCellDef="let row">{{ row.individualSessionCount }}</td>
            <td mat-footer-cell *matFooterCellDef><b>{{ totalIndividual }}</b></td>
          </ng-container>

          <!-- Group Sessions -->
          <ng-container matColumnDef="groupSessionCount">
            <th mat-header-cell *matHeaderCellDef>Group</th>
            <td mat-cell *matCellDef="let row">{{ row.groupSessionCount }}</td>
            <td mat-footer-cell *matFooterCellDef><b>{{ totalGroup }}</b></td>
          </ng-container>

          <!-- Follow-Up -->
          <ng-container matColumnDef="followUpCount">
            <th mat-header-cell *matHeaderCellDef>Follow-Up</th>
            <td mat-cell *matCellDef="let row">{{ row.followUpCount }}</td>
            <td mat-footer-cell *matFooterCellDef><b>{{ totalFollowUp }}</b></td>
          </ng-container>

          <!-- Total -->
          <ng-container matColumnDef="totalSessionCount">
            <th mat-header-cell *matHeaderCellDef>Total</th>
            <td mat-cell *matCellDef="let row">
              <b>{{ row.individualSessionCount + row.groupSessionCount + row.followUpCount }}</b>
            </td>
            <td mat-footer-cell *matFooterCellDef>
              <b style="color:#e53935;">{{ totalIndividual + totalGroup + totalFollowUp }}</b>
            </td>
          </ng-container>

          <!-- Sessions Observed (only for Dwani and Ankita) -->
          <ng-container matColumnDef="SessionObservedCount">
            <th mat-header-cell *matHeaderCellDef>Sessions Observed</th>
            <td mat-cell *matCellDef="let row">
              <b *ngIf="row.userName === 'Dwani' || row.userName?.toLowerCase()?.startsWith('dwani') || row.userName?.toLowerCase()?.startsWith('ankita')">{{ row.sessionObserve }}</b>
              <span *ngIf="!(row.userName === 'Dwani' || row.userName?.toLowerCase()?.startsWith('dwani') || row.userName?.toLowerCase()?.startsWith('ankita'))">-</span>
            </td>
            <td mat-footer-cell *matFooterCellDef><b>{{ tableObservedTotal }}</b></td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="teacherColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: teacherColumns;"></tr>
          <tr mat-footer-row *matFooterRowDef="teacherColumns; sticky: true" class="footer-row"></tr>
        </table>
      </div>

      <!-- ── Centre Children Summary Table ── -->
      <div class="mt-4 mb-2">
<!--        <div class="d-flex justify-content-between align-items-center mb-2">-->
<!--          <h1 class="mb-0">Centre Children Summary</h1>-->
<!--          <small class="text-muted">Children currently allotted to centre</small>-->
<!--        </div>-->

        <!-- Filters -->
        <div class="d-flex gap-2 mb-3 flex-wrap align-items-center">
          <!-- Date Range -->
          <mat-form-field appearance="outline" class="col-md-6">
            <mat-label>Enter a date range</mat-label>
            <mat-date-range-input [rangePicker]="childPicker">
              <input matStartDate [(ngModel)]="childStartDate" placeholder="Start date">
              <input matEndDate [(ngModel)]="childEndDate" placeholder="End date">
            </mat-date-range-input>
            <mat-hint>DD/MM/YYYY – DD/MM/YYYY</mat-hint>
            <mat-datepicker-toggle matSuffix [for]="childPicker"></mat-datepicker-toggle>
            <mat-date-range-picker #childPicker></mat-date-range-picker>
          </mat-form-field>

          <!-- Centre Multi-Select -->
          <app-searchable-select class="col-md-4"
                                 [multiple]="true"
                                 [options]="centres$ | async"
                                 displayKey="centreName"
                                 [valueKey]="'centreCode'"
                                 [selectedValue]="childSelectedCentreObjects"
                                 placeholder="Select Centre"
                                 label="Select Centre"
                                 (selectionChange)="onChildCentreSelect($event)">
          </app-searchable-select>

          <!-- Search & Clear Buttons -->
          <div class="d-flex align-items-center gap-2">
            <button mat-mini-fab color="accent" (click)="searchChildrenTable()" matTooltip="Search">
              <mat-icon>search</mat-icon>
            </button>
            <button mat-mini-fab color="warn" (click)="clearChildFilters()" matTooltip="Clear filters">
              <mat-icon>clear</mat-icon>
            </button>
          </div>
        </div>
                  <h1 class="text-center">Session Count Table</h1>

        <div *ngIf="centreChildrenDataSource.data.length === 0" class="text-muted text-center py-3">
          Select centres and click search to load children summary.
        </div>
        <div class="table-responsive" *ngIf="centreChildrenDataSource.data.length > 0">
          <table class="children-summary-table w-100 mb-2">
            <thead class="text-center">
              <tr>
                <th rowspan="2">Sr.</th>
                <th rowspan="2">Centre</th>
                <th colspan="2">Below 14</th>
                <th colspan="2">Above 14</th>
                <th rowspan="2">Total</th>
              </tr>
              <tr>
                <th>New</th>
                <th>Follow-up</th>
                <th>New</th>
                <th>Follow-up</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of centreChildrenDataSource.data">
                <td>{{ row.srNo }}</td>
                <td class="text-start">{{ row.centreName }}</td>
                <td>{{ row.below14New }}</td>
                <td>{{ row.below14Foll }}</td>
                <td>{{ row.above14New }}</td>
                <td>{{ row.above14Foll }}</td>
                <td><b>{{ row.total }}</b></td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="2"><b>Total</b></td>
                <td><b>{{ totalBelow14New }}</b></td>
                <td><b>{{ totalBelow14Foll }}</b></td>
                <td><b>{{ totalAbove14New }}</b></td>
                <td><b>{{ totalAbove14Foll }}</b></td>
                <td><b>{{ totalCentreChildren }}</b></td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>

      <!-- ─── Session Attribution Report ─── -->
      <section class="mt-3" *ngIf="debugReport && showDebugButton">
        <div class="d-flex align-items-center gap-3 mb-2">
          <button mat-stroked-button color="primary" (click)="showDebugPanel = !showDebugPanel">
            <mat-icon>{{ showDebugPanel ? 'visibility_off' : 'analytics' }}</mat-icon>
            {{ showDebugPanel ? 'Hide' : 'Show' }} Session Attribution Report
            <span class="badge bg-danger ms-1" *ngIf="debugReport.diff.total > 0">
              {{ debugReport.diff.total }} unaccounted
            </span>
            <span class="badge bg-success ms-1" *ngIf="debugReport.diff.total === 0">✓ Fully accounted</span>
          </button>
        </div>

        <div *ngIf="showDebugPanel" class="p-3 border rounded" style="background:#fafafa;">

          <!-- Summary row -->
          <div class="row mb-3 text-center">
            <div class="col-md-4">
              <div class="card border-secondary">
                <div class="card-body py-2">
                  <div class="text-muted" style="font-size:12px;">RAW (summaryDocs total)</div>
                  <strong>Ind: {{debugReport.rawTotals.individual}} &nbsp;|&nbsp;
                          Grp: {{debugReport.rawTotals.group}} &nbsp;|&nbsp;
                          FU:  {{debugReport.rawTotals.followUp}}</strong>
                  <div><span class="badge bg-secondary">Total: {{debugReport.rawTotals.total}}</span></div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="card border-primary">
                <div class="card-body py-2">
                  <div class="text-muted" style="font-size:12px;">CARDS (shown on dashboard)</div>
                  <strong>Ind: {{debugReport.cardTotals.individual}} &nbsp;|&nbsp;
                          Grp: {{debugReport.cardTotals.group}} &nbsp;|&nbsp;
                          FU:  {{debugReport.cardTotals.followUp}}</strong>
                  <div><span class="badge bg-primary">Total: {{debugReport.cardTotals.total}}</span></div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="card" [ngClass]="debugReport.diff.total > 0 ? 'border-danger' : 'border-success'">
                <div class="card-body py-2">
                  <div class="text-muted" style="font-size:12px;">DIFFERENCE (Raw − Cards)</div>
                  <strong [style.color]="debugReport.diff.individual > 0 ? '#dc3545' : 'inherit'">
                    Ind: {{debugReport.diff.individual}} &nbsp;|&nbsp;
                    Grp: {{debugReport.diff.group}} &nbsp;|&nbsp;
                    FU:  {{debugReport.diff.followUp}}
                  </strong>
                  <div>
                    <span class="badge" [ngClass]="debugReport.diff.total > 0 ? 'bg-danger' : 'bg-success'">
                      Total: {{debugReport.diff.total}}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- No discrepancy message -->
          <div *ngIf="debugReport.logs.length === 0" class="alert alert-success">
            ✅ No attribution needed — all sessions already matched to teachers correctly.
          </div>

          <!-- Attribution log table -->
          <div *ngIf="debugReport.logs.length > 0">
            <p class="fw-bold mb-2" style="color:#0d6efd;">
              ℹ️ {{debugReport.logs.length}} attribution entries — sessions excluded or unmatched:
            </p>
            <div class="table-responsive">
              <table class="table table-sm table-bordered table-hover" style="font-size:13px;">
                <thead class="table-dark">
                  <tr>
                    <th>#</th>
                    <th>Attribution</th>
                    <th>Original Teacher Name</th>
                    <th>Normalized Key</th>
                    <th>Centre</th>
                    <th>Docs</th>
                    <th class="text-end">Individual</th>
                    <th class="text-end">Group</th>
                    <th class="text-end">Follow-Up</th>
                    <th class="text-end">Sub-Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let log of debugReport.logs; let i = index"
                      [ngClass]="getLogRowClass(log.reason)">
                    <td>{{i+1}}</td>
                    <td>
                      <span class="badge" [ngClass]="getLogBadgeClass(log.reason)">
                        {{log.reason}}
                      </span>
                    </td>
                    <td><em>{{log.teacherName}}</em></td>
                    <td><code>{{log.normalizedKey || '—'}}</code></td>
                    <td>{{log.centreCode || '—'}}</td>
                    <td class="text-center">{{log.docCount ?? '—'}}</td>
                    <td class="text-end fw-bold">{{log.individual}}</td>
                    <td class="text-end fw-bold">{{log.group}}</td>
                    <td class="text-end fw-bold">{{log.followUp}}</td>
                    <td class="text-end fw-bold">{{log.individual + log.group + log.followUp}}</td>
                  </tr>
                </tbody>
                <tfoot class="table-secondary fw-bold">
                  <tr>
                    <td colspan="6" class="text-end">Total unaccounted sessions:</td>
                    <td class="text-end">{{ totalAttributedIndividual }}</td>
                    <td class="text-end">{{ totalAttributedGroup }}</td>
                    <td class="text-end">{{ totalAttributedFollowUp }}</td>
                    <td class="text-end">{{ totalAttributedIndividual + totalAttributedGroup + totalAttributedFollowUp }}</td>
                  </tr>
                </tfoot>
              </table>
            </div>
            <p class="text-muted" style="font-size:11px;">
              Generated: {{debugReport.generatedAt | date:'dd MMM yyyy, hh:mm:ss a'}} &nbsp;|&nbsp;
              Mode: <strong>{{teachersType}}</strong> &nbsp;|&nbsp;
              Date range: <strong>{{dateRangeLabel}}</strong>
            </p>
            <div class="alert alert-light border mt-2" style="font-size:12px;">
              <strong>Attribution Legend:</strong><br>
              ⚫ <strong>Empty Name (Excluded)</strong> — Summary docs with null/empty <code>teacherName</code>. These sessions are not shown in the dashboard.<br>
              🔵 <strong>Excluded Name (Filtered)</strong> — Sessions filed under system accounts (admin, na, etc.). Excluded from counts.<br>
              🟡 <strong>Unmatched (Active Mode)</strong> — Teacher has sessions in summary but no active employee record (only in Active mode).
            </div>
          </div>
        </div>
      </section>
      <br>

<!--      &lt;!&ndash; ── Centre Session Breakdown Chart ── &ndash;&gt;-->
<!--      <div class="row m-1 mt-4">-->
<!--        <div class="col-12">-->
<!--          <mat-card class="mat-mdc-card mdc-card">-->
<!--            <mat-card-header class="mat-mdc-card-header header-style">-->
<!--              <div class="mat-mdc-card-header-text">-->
<!--                <mat-card-title class="mat-mdc-card-title">Centre Session Breakdown</mat-card-title>-->
<!--              </div>-->
<!--            </mat-card-header>-->
<!--            <mat-card-content>-->
<!--              <apx-chart-->
<!--                [series]="barChartOptions.series"-->
<!--                [chart]="barChartOptions.chart"-->
<!--                [xaxis]="barChartOptions.xaxis"-->
<!--                [yaxis]="barChartOptions.yaxis"-->
<!--                [dataLabels]="barChartOptions.dataLabels"-->
<!--                [stroke]="barChartOptions.stroke"-->
<!--                [fill]="barChartOptions.fill"-->
<!--                [legend]="barChartOptions.legend"-->
<!--                [colors]="barChartOptions.colors"-->
<!--                [grid]="barChartOptions.grid"-->
<!--                [tooltip]="barChartOptions.tooltip"-->
<!--                [plotOptions]="barChartOptions.plotOptions">-->
<!--              </apx-chart>-->
<!--            </mat-card-content>-->
<!--          </mat-card>-->
<!--        </div>-->
<!--      </div>-->

      <!-- ── Notifications ── -->
      <div class="col-12 mt-4" *ngIf="showNotifications">
        <mat-card>
          <mat-card-header>
            <mat-card-title>Notifications</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <table mat-table [dataSource]="notifications" class="mat-elevation-z2 w-100">
              <ng-container matColumnDef="sr">
                <th mat-header-cell *matHeaderCellDef>Sr.</th>
                <td mat-cell *matCellDef="let element; let i = index">{{ i + 1 }}</td>
              </ng-container>
              <ng-container matColumnDef="title">
                <th mat-header-cell *matHeaderCellDef>Title</th>
                <td mat-cell *matCellDef="let element">{{ element.title }}</td>
              </ng-container>
              <ng-container matColumnDef="message">
                <th mat-header-cell *matHeaderCellDef>Message</th>
                <td mat-cell *matCellDef="let element">{{ element.message }}</td>
              </ng-container>
              <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef>Date</th>
                <td mat-cell *matCellDef="let element">{{ element.time.toDate() | date:'dd-MM-yyyy hh:mm a' }}</td>
              </ng-container>
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef>Status</th>
                <td mat-cell *matCellDef="let element">
                  <span [ngClass]="element.status === 'Unread' ? 'text-danger' : 'text-success'">
                    {{ element.status }}
                  </span>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
          </mat-card-content>
        </mat-card>
      </div>

    </div>
  </section>
</div>
